import { rankingItems } from '@/mocks/homeData';

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-fire-line text-lg"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              黑料热度榜
            </h2>
          </div>
          <p className="text-sm text-foreground-500 font-body">实时更新，当前最火爆的网红黑料事件排行</p>
        </div>

        <div className="flex flex-col gap-3 md:gap-4">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href={item.href}
              className="group flex items-center gap-4 md:gap-5 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer no-underline"
            >
              <div
                className={`w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-heading font-bold text-sm shrink-0 ${
                  i === 0
                    ? 'bg-primary-500 text-background-50'
                    : i === 1
                      ? 'bg-accent-500 text-background-50'
                      : i === 2
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-secondary-100 text-secondary-700'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-sm md:text-base font-semibold text-foreground-900 font-heading block truncate">
                  {item.title}
                </span>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="text-xs text-foreground-500 font-label hidden sm:inline">
                  热度 {item.heat}
                </span>
                <i
                  className={`text-sm ${
                    item.trend === 'up'
                      ? 'ri-arrow-up-line text-primary-500'
                      : item.trend === 'down'
                        ? 'ri-arrow-down-line text-foreground-400'
                        : 'ri-subtract-line text-foreground-400'
                  }`}
                ></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}